import React, { useRef } from 'react'
import { CustomFab } from '@/apps/legacy/components/molecules/CustomFab'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'
import { generateTimestampLabel } from '@/features/yakureki/apis/audio'
import { usePostAudioMutation } from '@/features/yakureki'

interface AudioUploadButtonProps {
  pharmacistId?: string
}

export const AudioUploadButton: React.FC<AudioUploadButtonProps> = ({
  pharmacistId,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const uploadMutation = usePostAudioMutation()

  const handleButtonClick = () => {
    // input のクリックイベントを発火
    fileInputRef.current?.click()
  }

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      const label = generateTimestampLabel()
      await uploadMutation.mutateAsync({
        audioSource: file,
        label,
        pharmacistId,
      })
    }
    // 同じファイルを再選択できるようにリセット
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept="audio/*"
      />
      <CustomFab
        sx={{
          '&:hover': {
            backgroundColor: colorTokens.special.fabHover,
            color: '#fff',
          },
          bottom: 160,
        }}
        onClick={handleButtonClick}
        disabled={uploadMutation.isPending}
      >
        <FileUploadIcon style={{ fontSize: 35 }} />
      </CustomFab>
    </>
  )
}
